// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_ChecklistInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /implantacao/checklist_salvar — grava uma versão nova do checklist (Full). As regras
 * (itens travados, chaves, etapas) são conferidas por ChecklistDaImplantacao no controller.
 */
import type { Implantacao_ChecklistEtapaRow } from './Implantacao_ChecklistEtapaRow'
import type { Implantacao_ChecklistItemRow } from './Implantacao_ChecklistItemRow'
import { registerContract } from './validate'

export interface Implantacao_ChecklistInput {
etapas?: Implantacao_ChecklistEtapaRow[]
itens?: Implantacao_ChecklistItemRow[]
}

registerContract('Implantacao_ChecklistInput', {
  etapas: {
    type: 'array',
    required: false,
    items: {
      chave:  { type: 'string',  required: false },
      titulo: { type: 'string',  required: false },
      ordem:  { type: 'number',  required: false },
    },
  },
  itens: {
    type: 'array',
    required: false,
    items: {
      chave:           { type: 'string',  required: false },
      etapa:           { type: 'string',  required: false },
      titulo:          { type: 'string',  required: false },
      descricao:       { type: 'string',  required: false },
      tipo:            { type: 'string',  required: false },
      responsavel:     { type: 'string',  required: false },
      obrigatorio:     { type: 'boolean', required: false },
      automatico:      { type: 'boolean', required: false },
      libera_operacao: { type: 'boolean', required: false },
      travado:         { type: 'boolean', required: false },
    },
  },
})
